<template>
  <div v-redirect-if-no-permission:LOCATIONS>
    <DataTable
      :url="api.ACTIONS.LANDMARKS"
      :fieldsHiddenMain="[
        'deleted_at',
        'radius',
        'type',
        'landmark_type',
        'street_name',
        'street_number',
        'city',
        'clusters',
        'ejection_radius',
        'level',
        'parent_id',
        'ejection_polygon',
        'place_id',
        'formatted_address',
        'is_favorite',
        'is_passenger_favorite'
      ]"
      :titles="titles"
      :actionsExtraMain="actionsExtraMain"
      :formatter="formatter"
      :initialUrlSearchParams="addType"
      perPage="100"
      :title="$t('maps.stationList.stations')"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";

export default {
  name: "StationList",
  title() {
    return this.$t("maps.stationList.title");
  },
  components: { DataTable },
  computed: {
    titles() {
      return {
        id: "#",
        created_at: this.$t("maps.stationList.dateCreated"),
        updated_at: this.$t("maps.stationList.dateUpdated"),
      };
    },
    addType() {
      const par = new URLSearchParams();
      par.append("landmark_type", "STATION");
      return par;
    },
    actionsExtraMain() {
      return {
        edit: {
          action: (item) => `/stations/${item.id}`,
        },
        add: {
          link: `/stations/add`,
        },
      };
    },
    formatter() {
      return {
        created_at(value) {
          const date = new Date(value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const year = date.getFullYear();
          const hours = date.getHours().toString().padStart(2, "0");
          const minutes = date.getMinutes().toString().padStart(2, "0");
          return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        updated_at(value) {
          const date = new Date(value);
          const day = date.getDate().toString().padStart(2, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          const year = date.getFullYear();
          const hours = date.getHours().toString().padStart(2, "0");
          const minutes = date.getMinutes().toString().padStart(2, "0");
          return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        polygon(polygon) {
          if (polygon != null) {
            let smallest = Array(2).fill(Math.pow(2, 32));
            let biggest = Array(2).fill(-Math.pow(2, 32));
            for (let arr of polygon.coordinates[0]) {
              smallest[0] = Math.min(smallest[0], arr[0]);
              smallest[1] = Math.min(smallest[1], arr[1]);
              biggest[0] = Math.max(biggest[0], arr[0]);
              biggest[1] = Math.max(biggest[1], arr[1]);
            }
            return `
                            <svg height="75" width="75" viewBox="-75 0 75 75">
                                <polygon points="${polygon.coordinates[0]
                                  .map(
                                    (arr) =>
                                      (-(biggest[0] - arr[0]) /
                                        (biggest[0] - smallest[0])) *
                                        75 +
                                      "," +
                                      ((biggest[1] - arr[1]) /
                                        (biggest[1] - smallest[1])) *
                                        75
                                  )
                                  .join(
                                    " "
                                  )}" style="fill:lime;stroke:purple;stroke-width:1;"/>
                            </svg>
                        `;
          }
        },
        centroid(value) {
          return JSON.stringify(value.coordinates);
        },
      };
    },
  },
};
</script>

<style scoped></style>
